module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "1250",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "title ims-modal-header"
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("\n          Paired influencers for campaign:\n          "), _c('strong', [_vm._v(_vm._s(_vm.campaignCOEB.campaignName))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "ims-modal-body"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaignCOEB.min_content) + " to " + _vm._s(_vm.campaignCOEB.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), (_vm.measurement.totalPercentage && _vm.measurement.totalPercentage !== 'NaN' && _vm.measurement.totalPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + " %")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: -")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), (_vm.measurement.outreachPercentage && _vm.measurement.outreachPercentage !== 'NaN' && _vm.measurement.outreachPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: -")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.engagement)))]), _vm._v(" "), (_vm.measurement.engagementPercentage && _vm.measurement.engagementPercentage !== 'NaN' && _vm.measurement.engagementPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.engagementPercentage) + "%")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: -")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.isNotClientRole) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Budget")]), _vm._v(" "), _c('v-card-subtitle', [(_vm.budget) ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("currency")(_vm.budget)))]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : 0")]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.budget)))]), _vm._v(" "), (_vm.measurement.cogsPercentage && _vm.measurement.cogsPercentage !== 'NaN' && _vm.measurement.cogsPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.cogsPercentage) + "%")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: -")])])], 1)]
      }
    }], null, false, 2495958124)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0",
    staticStyle: {
      "justify-content": "right"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-select', {
    staticClass: "input-field pt-3",
    attrs: {
      "items": _vm.payoutStatusOptions,
      "item-value": "status",
      "item-text": "display",
      "label": "Payout Status",
      "dense": "",
      "outlined": ""
    },
    on: {
      "change": _vm.pairingSearchFilter
    },
    model: {
      value: (_vm.pairedFilter.payoutStatus),
      callback: function($$v) {
        _vm.$set(_vm.pairedFilter, "payoutStatus", $$v)
      },
      expression: "pairedFilter.payoutStatus"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "5",
      "md": "5",
      "lg": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.pairedFilter.search),
      callback: function($$v) {
        _vm.$set(_vm.pairedFilter, "search", $$v)
      },
      expression: "pairedFilter.search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1 page__table",
    attrs: {
      "headers": _vm.pairedHeaders,
      "items": _vm.pairedFilterItems,
      "items-per-page": 10,
      "search": _vm.pairedFilter.search,
      "no-data-text": 'Empty list'
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('tbody', _vm._l((props.items), function(item) {
          return _c('tr', {
            key: item.instagramHandle,
            class: {
              'yellow lighten-4': item.payoutSubmitted
            }
          }, [_c('td', [_c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": item.influencer_details.platform === 'tiktok',
              "isInstagram": !item.influencer_details.platform || item.influencer_details.platform === 'instagram',
              "isYoutube": item.influencer_details.platform === 'youtube',
              "isFacebook": item.influencer_details.platform === 'facebook',
              "isXiaohongshu": item.platform === 'xiaohongshu',
              "isOthers": item.platform === 'others',
              "tiktokHandle": item.instagramHandle,
              "instagramHandle": item.instagramHandle,
              "youtubeHandle": item.instagramHandle,
              "facebookHandle": item.instagramHandle,
              "otherHandle": item.instagramHandle
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [(item.influencer_details.platform === 'facebook') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(item.followers))])]), _vm._v(" "), _c('td', [(item.influencer_details.platform === 'facebook') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(item.engagement_rate) + "%")])]), _vm._v(" "), _c('td', [_c('v-icon', {
            attrs: {
              "color": item.audience_credibility_color
            }
          }, [_vm._v("supervised_user_circle")]), _vm._v("\n                      " + _vm._s(item.audience_credibility) + "\n                    ")], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.deliverables))]), _vm._v(" "), (_vm.isNotClientRole) ? _c('td', [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": _vm.payoutStatusColor(item.payoutStatus),
              "outlined": "",
              "small": ""
            }
          }, [_vm._v("\n                        " + _vm._s(_vm.payoutStatusDisplay[item.payoutStatus || 0]) + "\n                        "), _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("mdi-circle-edit-outline")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isNotClientRole) ? _c('td', {
            staticClass: "text-right"
          }, [_vm._v("$ " + _vm._s(item.payoutAmount))]) : _vm._e(), _vm._v(" "), _c('td', {
            staticClass: "text-center paired-actions-cell"
          }, [_c('div', {
            staticClass: "paired-actions"
          }, [(_vm.buttonShow('editPayout')) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "color": "secondary",
                    "aria-label": "Edit payout"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.openConfirmPayoutDialog(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-pencil")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Edit payout")])]) : _vm._e(), _vm._v(" "), (_vm.buttonShow('editPayout') && _vm.showConfirmPayout && item.payoutStatus !== _vm.payoutStatus.CONFIRMED) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "color": "primary",
                    "aria-label": "Confirm payout"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.updateSend(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary"
                  }
                }, [_vm._v("mdi-check")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Confirm payout")])]) : _vm._e(), _vm._v(" "), (_vm.buttonShow('editPayout') && _vm.showConfirmPayout && item.payoutStatus === _vm.payoutStatus.CONFIRMED) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "color": "error",
                    "aria-label": "Cancel payout"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.cancelPayout(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-cancel")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Cancel payout")])]) : _vm._e(), _vm._v(" "), (_vm.buttonPayoutViewShow(item)) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn ims-btn-third",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "aria-label": "View payouts"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.linkPayoutInternal(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-eye")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View payouts")])]) : _vm._e()], 1)])])
        }), 0)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('payout-confirm-modal', {
    attrs: {
      "value": _vm.payoutConfirmDialog,
      "data": _vm.payoutConfirmData,
      "influencer": _vm.influencer
    },
    on: {
      "confirmedPayout": _vm.setConfirmedPayout
    },
    model: {
      value: (_vm.payoutConfirmDialog),
      callback: function($$v) {
        _vm.payoutConfirmDialog = $$v
      },
      expression: "payoutConfirmDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fb90f2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/PairedInfAdminViewDialog.vue
// module id = 2065
// module chunks = 0